import { getApiConfig } from "@/config/api.config";
import { BaseApiService } from "@/services/api/BaseApiService";

export interface CustomerCategory {
  id: number;
  name: string;
  gender: string;
  createdAt: string;
  lastSeen: string;
  customerId: number;
  craveCategoryId: number | null;
}

export interface CategoryResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export class CategoryService extends BaseApiService {
  private static instance: CategoryService;

  private constructor() {
    super();
  }

  public static getInstance(): CategoryService {
    if (!CategoryService.instance) {
      CategoryService.instance = new CategoryService();
    }
    return CategoryService.instance;
  }

  private getCoreBaseUrl(): string {
    return getApiConfig().core;
  }

  public async getByCustomer(customerId: number): Promise<CategoryResponse<CustomerCategory[]>> {
    try {
      const response = await this.get<{ data: CustomerCategory[] }>(
        `/customerCategory/customer/${customerId}`,
        this.getCoreBaseUrl(),
      );
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : "Failed to fetch customer categories",
      };
    }
  }

  public async updateCustomerCategory(
    category: CustomerCategory,
  ): Promise<CategoryResponse<CustomerCategory>> {
    try {
      const response = await this.put<{ data: CustomerCategory }>(
        "/customerCategory",
        category,
        this.getCoreBaseUrl(),
      );
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : "Failed to update customer category",
      };
    }
  }
}
